var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          viewBox: "0 0 56 56"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#0ABF53",
          "fill-rule": "evenodd",
          d:
            "M13.658 0h28.69c4.758 0 6.486.5 8.22 1.427a9.652 9.652 0 0 1 4.004 4.035C55.506 7.202 56 8.923 56 13.678v28.677c0 4.755-.494 6.482-1.428 8.223a9.726 9.726 0 0 1-4.003 4.002c-1.735.927-3.463 1.42-8.22 1.42h-28.69c-4.758 0-6.486-.493-8.228-1.42a9.746 9.746 0 0 1-4.003-4.002C.494 48.838 0 47.11 0 42.355V13.678c0-4.755.494-6.475 1.428-8.216A9.672 9.672 0 0 1 5.43 1.427C7.186.5 8.901 0 13.658 0Z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          d:
            "M36.397 14.14h-21.79v7.004h14.32c.933 0 1.556.778 1.556 1.557v12.295H27.37c-.934 0-1.556-.778-1.556-1.556v-8.872h-6.07a5.58 5.58 0 0 0-5.604 5.603v6.226A5.58 5.58 0 0 0 19.744 42H42V19.743a5.58 5.58 0 0 0-5.603-5.603Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }